module.exports = __webpack_public_path__ + "img/a1-s4.f731131d.jpg";